import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Design system: FTM tokens → vCIP additions → the scoped .droom consumer layer. Import ONCE at the
// app root, BEFORE the svapp chrome so the app-shell background wins the .droom cascade.
import '@vcip/design-system/styles.css';
import './styles/svapp.css';

import { App } from './App';

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
